import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { useState } from "react";
import MessageBanner from "components/message-banner";

export default function ShippingLabelModal({
  shipping,
  setModalOpen,
  modalOpen,
  takebackId,
  weight,
}) {
  const labelUrl = shipping?.shipping_metadatas?.items?.find(
    (item) => item.key === "label_url"
  )?.value;

  const [labelLoaded, setLabelLoaded] = useState(false);

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between max-h-[90vh] min-h-[550px]"
    >
      <>
        <div className="flex flex-col justify-between">
          <div className="flex justify-end">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              <img src={CloseIcon} alt="" variant="secondary" />
            </div>
          </div>
          <div className="flex flex-col space-y-3 w-full items-center">
            {/* <img
              src="/static/media/logo.4f05a22b8fee49f8826e.jpg"
              alt="LEGO"
              className="w-12 h-12"
            /> */}

            <h2 className="text-3xl font-semibold text-center leading-snug -mb-4 mt-3">
              Present this shipping QR code at The&nbsp;UPS®&nbsp;Store.
            </h2>

            <div className="relative flex items-center justify-center w-64 h-64">
              {/* Spinner */}
              <div
                id="qr-spinner"
                className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${labelLoaded ? "opacity-0" : "opacity-100"}`}
              >
                <div className="w-16 h-16 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
              </div>
              {/* QR Image */}
              <img
                src={labelUrl}
                alt="QR Code"
                className="max-w-64"
                style={{
                  objectFit: "cover",
                  objectPosition: "center",
                  clipPath: "inset(10% 3%)",
                  position: "relative",
                  zIndex: 1,
                }}
                onLoad={() => setLabelLoaded(true)}
                onError={() => setLabelLoaded(true)}
              />
            </div>
            <div className="flex flex-col items-center mt-4 space-y-1">
              <div className="">
                TRADE-IN ID: <strong>{takebackId}</strong>
              </div>
              <div className="">
                ESTIMATED WEIGHT: <strong>{weight} lbs</strong>
              </div>
            </div>
          </div>
        </div>
        <MessageBanner
          colour="yellow"
          className="mt-8"
          body={
            <>
              <strong>Note:</strong> Each trade-in has a unique QR code meant
              for one package only — don’t reuse QR codes or split your trade-in
              across multiple packages.
            </>
          }
        ></MessageBanner>
      </>
    </Modal>
  );
}
